// @flow
import CommonPage from './CommonPage';

export default CommonPage;
